import { toMoney } from "../../Components/Functions";
import { profile, reviews } from "./data";
import { UPDATE } from "./types";

const INITIAL_STATE = {
	profile: {},
	reviews: {}
};

export const reducer = (state = INITIAL_STATE, action) => {
	switch (action.type) {
		case UPDATE:
			return {
				...state,
				...action
			};

		default:
			return state;
	}
};


